import { createContext, useContext, useState } from "react";


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [token, setToken] = useState(localStorage.getItem("token") || "");
    const [usertype, setUserType] = useState(localStorage.getItem("userType") || "");
    const [userData, setUserData] = useState(localStorage.getItem("userData") || "");
    const wspath = "wss://testview.in:8080/app/op0spjuz1jacssyup5xe";
    const apipath = "https://testview.in/api/v1";
    const filepath = "https://testview.in/api/v1";
    const socketpath = "https://testview.in";

    // const wspath = "ws://127.0.0.1:8080/app/op0spjuz1jacssyup5xe";
    // const apipath = "http://localhost:5000/api/v1";
    // const filepath = "http://localhost:5000/api/v1";
    // const socketpath = "http://localhost:5000";
    
    // const wspath = "ws://127.0.0.1:8080/app/op0spjuz1jacssyup5xe";
    // const apipath = "/api/v1";
    // const filepath = "/api/v1";
    // const socketpath = window.location.origin;
    // console.log(socketpath);
    // 192.168.31.146

    const login = (newToken, newUserType, newUserData) => {
        localStorage.setItem("token", newToken);
        localStorage.setItem("userType", newUserType);
        localStorage.setItem("userData", newUserData);

        setToken(newToken);
        setUserType(newUserType);
        setUserData(newUserData);
        setIsLoggedIn(true);
    };

    const goBack = () => {
        window.history.back();
    }

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userType");
        localStorage.removeItem("userData");

        setToken("");
        setUserType("");
        setUserData("");
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, apipath, filepath, socketpath, login, goBack, logout, wspath, token, usertype, userData }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);